// Get the date in the required format
export function getDateInFormat (timeStamp) {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  const getDate = timeStamp.getDate();
  const getYear = timeStamp.getFullYear();
  const getMonth = `${months[new Date(timeStamp).getMonth()]}`;
  const fullDate = `${getDate} ${getMonth} ${getYear}`;
  return fullDate;
}

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
